import NetworkLogic from "../../Shared/NetworkLogic";
import Utils from "../../Shared/Utils";
import Network from "../../Shared/Network";
import Constant from "../../Shared/Constant";
import UIManager from "../../Shared/UIManager";
import AudioManager from "../../Shared/AudioManager";

const {ccclass, property} = cc._decorator;

@ccclass
export default class CommitData extends cc.Component {

    @property(cc.Node)
    content: cc.Node[] = [];
    @property(cc.Button)
    btnSubmit: cc.Button = null;
    @property(cc.EditBox)
    editBox: cc.EditBox = null;
    @property(cc.Node)
    NewLab: cc.Node = null;
    private strUrl = null;
    private submitType :string  =  "" ;//1  账号 ；2，图片；3：视频
    private id: string = "";
    private applyMode: string = "";

    onLoad () {
        this.node.on("COMMITDATA",this.updateUI.bind(this))
    }

    onEnable () {
        console.log("=====子界面打开")

    }
    updateUI(param){
        let pa = param.split(",");
        this.id = pa[0];
        this.applyMode = pa[1];
        this.submitType = pa[2] ;
        cc.log("===this.submitType",this.submitType);
        for (let i  = 0; i < this.content.length;i++){
            this.content[i].active = false;
        }
        this.content[Number(this.submitType) - 1].active = true;
        if (this.submitType === "1"){//提交好友账号
	        this.editBox.node.active = true;
            this.editBox.placeholder = "好友账号";
            this.NewLab.active = false;
        }
        else if (this.submitType === "2"){//提交图片
            this.editBox.node.active = false;
            this.NewLab.active = true;
            this.NewLab.getChildByName("labHttp").getComponent(cc.Label).string = "上传图片"

        }else if (this.submitType === "3"){//提交视频
            this.editBox.node.active = false;
            this.NewLab.active = true;
            this.NewLab.getChildByName("labHttp").getComponent(cc.Label).string = "上传视频"
        }
        this.btnSubmit.clickEvents[0].customEventData = this.id ;
    }

    onBtnClick(event,param){
        AudioManager.playSound("button");
        console.log("===点击onBtnClick");
        if (param === "close"){
            AudioManager.playSound("close")
            this.node.active = false;
        }
        else if (param === "image"){//上传
            console.log("===点击打开相册");
            Utils.pickImageFromAlbum("image",function (path:string) {
                cc.log("=====打开相册的path",path);
                cc.log(path);
                let sts = path.split("/");
                let fileName =  sts[sts.length -1];
                let size = jsb.fileUtils.getFileSize(path);
                if (size >= 1024*1024){
                    UIManager.showToastUI("上传图片大小不能超过1M");
                    return;
                }

                UIManager.showLoadingUI();
                NetworkLogic.uploadFile(fileName, jsb.fileUtils.getDataFromFile(path),function (rec) {
                    console.log("=====上传照片之后返回",rec);
                    //this.editBox.string = rec.url;
                    UIManager.hideLoadingUI();
                    this.strUrl = rec.path;
                    this.NewLab.getChildByName("labHttp").getComponent(cc.Label).string = this.strUrl;
                }.bind(this),function () {
                    cc.log("====照片上传错误");
                }.bind(this))

            }.bind(this));
        }
        else if (param === "video"){//上传视频
            console.log("===点击打开视频");
            Utils.pickImageFromAlbum("video",function (path:string) {
                cc.log("=====打开视频的path",path);
                cc.log(path);
                let sts = path.split("/");
                let fileName =  sts[sts.length -1];
                let size = jsb.fileUtils.getFileSize(path);
                if (size > 1024*1024 *2){
                    UIManager.showToastUI("上传图片大小不能超过2M");
                    return;
                }

                UIManager.showLoadingUI();
                NetworkLogic.uploadFile(fileName, jsb.fileUtils.getDataFromFile(path),function (rec) {
                    console.log("=====上传视频之后返回",rec);

                    //this.editBox.string = rec.url;
                    UIManager.hideLoadingUI();
                    this.strUrl = rec.path;
                    this.NewLab.getChildByName("labHttp").getComponent(cc.Label).string = this.strUrl;
                }.bind(this),function () {
                    cc.log("====照片视频错误");
                }.bind(this))

            }.bind(this));
        }
    }
    onBtnSubmit(event,param){
        AudioManager.playSound("button");
        let data2 = null
        if (this.submitType === "1"){//好友账号
            if (!this.editBox.string){
                UIManager.showToastUI("请先输入账号");
                return;
            }
            data2 = {
                taskId:param,
                friendUserId:this.editBox.string
            }

        }else if (this.submitType === "2" ){//照片
            cc.log("=== 点击上传图片 imageUrl：",this.strUrl);
            if (!this.strUrl){
                UIManager.showToastUI("请先上传图片");
                return;
            }
            data2 = {
                friendUserId:"",
                taskId:param,
                imageUrl:this.strUrl,
                videoUrl:""
            }
        }
        else if (this.submitType === "3"){//视频
            if (!this.strUrl){
                UIManager.showToastUI("请先上传视频");
                return;
            }
            data2 = {
                friendUserId:"",
                taskId:param,
                imageUrl:"",
                videoUrl:this.strUrl
            }
        }
        UIManager.showLoadingUI();
        NetworkLogic.agentApplicationReward(data2,function (rec) {
            UIManager.hideLoadingUI();
            UIManager.showTipUI("提交申请成功，请等待审核");

        },function () {
            console.log("=====提交错误")
        })


    }


    onDestroy(): void {
        this.node.off("COMMITDATA")
    }
}
